// Number formatting shared by the admin screen's summary cards and members table.

/** Whole transcribed minutes (batch+streaming summed by the caller) from a seconds count. */
export function formatMinutes(seconds: number): string {
  return `${Math.round(seconds / 60)} min`;
}

export function formatGb(bytes: number): string {
  return `${(bytes / 1024 ** 3).toFixed(2)} GB`;
}

export function formatTokens(tokensIn: number, tokensOut: number): string {
  return `${tokensIn.toLocaleString()} in / ${tokensOut.toLocaleString()} out`;
}
